import React, {useState} from "react";
import FileService from "../../../API/orders/orders/customer/FileService";
import {Box, Button} from "@mui/material";
import {ButtonGroupTabBar} from "../../../components/UI/button/ButtonGroupTabBar";
import CheckIcon from "@mui/icons-material/Check";
import FilesTable from "../../../components/UI/table/common/files/FilesTable";
import UploadOrderFilesForm from "../../../components/form/UploadOrderFilesForm";
import UtilityCustomerService from "../../../API/customer/UtilityCustomerService";
import UtilityService from "../../../API/common/UtilityService";

const FilesItem = ({
                       nameOrder,
                       year,
                       orderId,
                       change,
                       setChange,
                       handleModalAlert,
                       customer,
                       orderCustomerInOrganization
                   }) => {
    const service = customer ? UtilityCustomerService : UtilityService
    const [tab, setTab] = useState(1);
    const handleChange = (event, newValue) => {
        setTab(newValue);
    };

    return (
        <Box sx={{display: "flex", flexDirection: "column", gap: "32px"}}>
            <ButtonGroupTabBar activeTab={tab}>
                <Button tabIndex={1} onClick={(e) => handleChange(e, 1)}>
                    <CheckIcon/>
                    Файлы проекта
                </Button>
                {!orderCustomerInOrganization && <Button tabIndex={2} onClick={(e) => handleChange(e, 2)}>
                    <CheckIcon/>
                    Импорт
                </Button>}
            </ButtonGroupTabBar>
            {tab === 1 ? <FilesTable
                customer={customer}
                nameOrder={nameOrder}
                year={year}
                orderId={orderId}
                change={change}
                setChange={setChange}
                handleModalAlert={handleModalAlert}
                orderCustomerInOrganization={orderCustomerInOrganization}
                service={service}
            /> : <Box>
                <UploadOrderFilesForm
                    label={"Загрузить файлы проекта"}
                    year={year}
                    nameOrder={nameOrder}
                    fileNameType={"PROJECT"}
                    uploadData={{
                        id: 1,
                        helpText: "Загрузить файлы проекта",
                        upload: service.uploadOrderFile
                    }}
                    orderId={orderId}
                    change={change}
                    setChange={setChange}
                    calculationRequestsCutting={false}
                    handleModalAlert={handleModalAlert}
                />
            </Box>}

        </Box>
    );
};

export default FilesItem